module.exports = __webpack_public_path__ + "img/10_97.deac466c.png";